import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const AkcniProdejNdPolozky = {
	name: NAME,
	apiProvider,
	router,
};
